__turbopack_context__.v({
  "goToTop": "g3pVxq_goToTop",
});
